import React, { useEffect } from 'react';
import { styled } from 'linaria/react';

import Image from '@jetshop/ui/Image';
import { Above } from '@jetshop/ui/Breakpoints';
import { GallerySwiper } from './GallerySwiper';
import { theme } from '../../../Theme';
import { useCustomFields } from '../useCustomFields';
import Player from '@vimeo/player';

const GalleryWrapper = styled('div')`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  grid-gap: 0px;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  background-color: #ffffff;
  min-width: 100px;
  margin-bottom: 20px;

  ${theme.below.lg} {
    display: flex;
  }

  ${theme.above.lg} {
    ${'' /* max-width: 70vw; */}
    margin: 0 auto;
    height: 100%;
  }

  [data-flight-image-container] {
    background: white;
  }

  &.single-image-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 100%;
    background: white;

    @media screen and (min-width: 1500px) {
      max-width: 70%;
      margin: auto;
    }
  }

  ${theme.below.lg} {
    /* margin-bottom: 10px; */
    margin-bottom: 0;
  }

  .thumbs-wrapper {
    display: none;
  }

  .carousel .slider {
    gap: 20px;
  }
  .carousel.carousel-slider .control-arrow {
    height: 50px;
    width: 50px;
    background: #004e42;
    opacity: 0.7;
    border-radius: 100%;
    top: 50%;
    transform: translateY(-50%);
    transition: all, 0.2s ease;

    &:hover {
      opacity: 1;
    }
    &.control-next {
      right: 20px;
    }
    &.control-prev {
      left: 20px;
    }
  }

  .image-background {
    background: red;
  }
`;

const GalleryImage = styled('div')`
  width: 100%;
  flex: 1;
  overflow: hidden;

  &.single-image {
    width: 50%;
    margin: auto;
    max-width: 47rem;

    ${theme.below.lg} {
      width: 100%;
    }
  }
`;

const MobileSlider = styled('div')`
  /* gap: 10px;
    padding: 0 10px; */
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;

  &::-webkit-scrollbar,
  &::-webkit-scrollbar-track,
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
    display: none;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .gallery-image {
    min-width: 100vw;
  }
`;

const Gallery = ({ product }) => {
  const mobileSliderRef = React.useRef(null);
  const { vimeoId } = useCustomFields(product);
  useEffect(() => {
    if (mobileSliderRef.current) {
      const slider = mobileSliderRef.current;
      const handleScroll = () => {
        stopVimeo();
      };

      slider.addEventListener('scroll', handleScroll);

      return () => {
        slider.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  function stopVimeo() {
    const iframes = document.querySelectorAll('iframe[title="vimeo-player"]');
    if (iframes.length > 0) {
      iframes.forEach(iframe => {
        if (iframe.src !== '') {
          const player = new Player(iframe);
          player.pause();
        }
      });
    }
  }

  if (!product) return null;
  const images = product?.images ?? [];
  const noImage =
    'https://willabb2c-hansbo.jetshop.se/pub_docs/files/Hmissing.jpg';

  return (
    <Above breakpoint="lg">
      {matches => {
        return (
          <GalleryWrapper
            className={
              images.length <= 1 && !vimeoId
                ? 'single-image-wrapper'
                : 'gallery'
            }
          >
            {images.length === 0 ? (
              <>
                <GalleryImage className="gallery-image single-image">
                  <Image
                    src={noImage}
                    alt={product?.name}
                    title={images[0]?.title}
                    aspect={'1:1'}
                    sizes={'755'}
                    quality={90}
                  />
                </GalleryImage>
              </>
            ) : (
              <>
                {images.length === 1 && !vimeoId ? (
                  <>
                    <GalleryImage className="gallery-image single-image">
                      <Image
                        src={images?.[0]?.url}
                        alt={product?.name}
                        title={images?.[0]?.title}
                        aspect={'1:1'}
                        sizes={'755'}
                        quality={90}
                        modifiedDate={images?.[0]?.modifiedDate}
                      />
                    </GalleryImage>
                  </>
                ) : (
                  <>
                    {matches ? (
                      <>
                        {images.map((image, index) => {
                          return (
                            <GalleryImage key={index}>
                              <Image
                                src={image?.url}
                                alt={product?.name}
                                title={image?.title}
                                aspect={'1:1'}
                                sizes={'755'}
                                crop={true}
                                quality={90}
                                modifiedDate={image?.modifiedDate}
                              />
                            </GalleryImage>
                          );
                        })}
                        {vimeoId && (
                          <GalleryImage
                            className="vimeoPlayer"
                            key={`vimeo-${vimeoId.value}`}
                          >
                            <iframe
                              title="vimeo-player"
                              src={`https://player.vimeo.com/video/${vimeoId?.value}?h=9a60ec7769`}
                              width="1000"
                              height="1000"
                              frameborder="0"
                              allowfullscreen
                              style={{ width: '100%', height: '100%' }}
                            ></iframe>
                          </GalleryImage>
                        )}
                      </>
                    ) : (
                      <MobileSlider ref={mobileSliderRef}>
                        {images.map((image, index) => {
                          return (
                            <GalleryImage key={index} className="gallery-image">
                              <Image
                                src={image.url}
                                alt={product?.name}
                                title={image.title}
                                aspect={'1:1'}
                                sizes={'755'}
                                crop={true}
                                quality={90}
                                modifiedDate={image.modifiedDate}
                              />
                            </GalleryImage>
                          );
                        })}
                        {vimeoId && (
                          <GalleryImage
                            key={`vimeo-${vimeoId.value}`}
                            className="gallery-image"
                          >
                            <iframe
                              title="vimeo-player"
                              src={`https://player.vimeo.com/video/${vimeoId?.value}?h=9a60ec7769`}
                              width="1000"
                              height="1000"
                              frameborder="0"
                              allowfullscreen
                              style={{ width: '100%', height: '100%' }}
                            ></iframe>
                          </GalleryImage>
                        )}
                      </MobileSlider>
                    )}
                  </>
                )}
              </>
            )}
          </GalleryWrapper>
        );
      }}
    </Above>
  );
};

export default Gallery;
